export const NAME = 'reports'

export default { NAME }
